import { render, staticRenderFns } from "./WebsiteInterfaceDesktop.vue?vue&type=template&id=3da65b56&scoped=true&"
import script from "./WebsiteInterfaceDesktop.vue?vue&type=script&lang=js&"
export * from "./WebsiteInterfaceDesktop.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteinterfaceDesktop.css?vue&type=style&index=0&id=3da65b56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da65b56",
  null
  
)

export default component.exports